module.exports = __webpack_public_path__ + "static/media/shape01a-mob.592c63c6.svg";